const page = {
    loadScript: function(url, success, failure) {
        var script = document.createElement('script');

        function cb() {
            if (typeof success === 'function') {
                success();
            }
        }

        script.async = true;
        script.type = 'text/javascript';

        if (script.readyState) {
            //IE
            script.onreadystatechange = function() {
                if (script.readyState == 'loaded' || script.readyState == 'complete') {
                    script.onreadystatechange = null;
                    cb();
                }
            };
        } else {
            //Others
            script.onload = function() {
                cb();
            };
        }

        if (typeof failure === 'function') {
            script.onerror = failure;
        }

        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
    },
    isMobile: function() {
        return smartPak.pageData && typeof smartPak.pageData.isMobile !== 'undefined'
            ? smartPak.pageData.isMobile
            : this.isSmallScreen();
    },
    isSmallScreen: function(){
        return window.matchMedia('(max-width: 767px)').matches;
    },
    redirectToUrl: function(url) {
        if (url) {
            window.location.href = url;
        }
    },
    resolveLazyLoadedImages: function(element) {
        var lazyArray = [].slice.call(document.querySelectorAll(element + ' .lazy'));

        lazyArray.forEach(function(item) {
            if (!item.classList.contains('lazyLoaded')) {
                var newSrc = item.getAttribute('data-src');

                item.classList.add('lazyLoaded');
                item.setAttribute('src', newSrc);
            }
        });
    }
};

export default page;
